module.exports = __webpack_public_path__ + "static/media/rightStrap.df14b121.png";